// Holiday specials of Pixley Originals.
// A special is published with episode_number 100+ so it always sorts after the regular run and new
// episodes never reorder it. Specials are free for everyone, carry their own badge instead of
// "Episode N", and can get a seasonal hero slide on the Storyverse page while their window is open.
export const SPECIAL_EPISODE_NUMBER = 100;

export const isSpecialEpisode = (episode) => (Number(episode?.episode_number) || 0) >= SPECIAL_EPISODE_NUMBER;

// "The Ghost of Hollow House (Halloween Special)" -> "Halloween special"
export const getSpecialLabel = (episode) => {
  const m = /\(([^)]*special)\)\s*$/i.exec(episode?.name || '');
  return m ? m[1].charAt(0).toUpperCase() + m[1].slice(1).toLowerCase() : 'Special';
};

// The title without its "(… Special)" suffix, for places that already show the badge.
export const getSpecialTitle = (episode) => (episode?.name || '').replace(/\s*\([^)]*special\)\s*$/i, '');

// Seasonal hero slides. `until` is the first local day the slide no longer shows.
export const SEASONAL_SPECIALS = [
  {
    id: 'special-halloween-2026',
    showId: '50ae118b-7dac-4127-a3ce-469830db017e', // Hello, Watts!
    episodeId: 'a57ddae8-ecbf-481a-9269-463e28a38d90',
    until: '2026-11-02',
    badge: 'Halloween special',
    icon: 'nights_stay',
    accent: '#FF8A1F',
    title: 'The Ghost of Hollow House',
    hook: 'A spooky-cute Hello, Watts! special. Free to watch.',
    cta: 'Watch now',
    img: '/assets/banner/promo_halloween.webp',
    focus: '72% 45%',
  },
];

export const getActiveSeasonalSpecials = (now = new Date()) => {
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  return SEASONAL_SPECIALS.filter((s) => today < s.until);
};
